//calendar.js
import { firestore } from "../../firebase";

const schedule = firestore.collection("calendar");

//Action
const LOAD = "calendar/LOAD";
const DELETE_SCHEDULE = "calendar/DELETE_SCHEDULE";
const UPDATE_SCHEDULE = "calendar/UPDATE_SCHEDULE";
const ADD_SCHEDULE = "calendar/ADD_SCHEDULE";

const initialState = {
  schedules: [
    { date: "2021-04-15T02:17", desc: "리액트 잘하기", completed: false },
    { date: "2021-03-25T22:05", desc: "도리 쓰다듬기", completed: false },
    { date: "2021-03-25T19:17", desc: "캘린더 사용하기", completed: false },
    { date: "2021-03-15T02:17", desc: "디버깅", completed: false },
  ],
};
// Action Creators
export const loadSchedule = (schedule) => {
  return { type: LOAD, schedule };
};
export const deleteSchedule = (desc) => {
  return { type: DELETE_SCHEDULE, desc };
};
export const updateSchedule = (desc) => {
  return { type: UPDATE_SCHEDULE, desc };
};
export const addSchedule = (schedule) => {
  return { type: ADD_SCHEDULE, schedule };
};

// 파이어베이스랑 통신하는 부분
export const loadFB = () => {
  return function (dispatch) {
    schedule.get().then((docs) => {
      let schedule_data = [];
      docs.forEach((doc) => {
        if (doc.exists) {
          schedule_data = [...schedule_data, { id: doc.id, ...doc.data() }];
        }
      });
      // 이제 액션 생성 함수한테 우리가 가져온 데이터를 넘겨줘요! 그러면 끝!
      dispatch(loadSchedule(schedule_data));
    });
  };
};

export const addScheduleFB = (date, desc) => {
  return function (dispatch) {
    console.log(date, desc);
    // 생성할 데이터를 미리 만들게요!
    let schedule_data = { date: date, desc: desc, completed: false };

    // add()에 데이터를 넘겨줍시다!
    schedule
      .add(schedule_data)
      .then((docRef) => {
        // id를 추가한다!
        schedule_data = { ...schedule_data, id: docRef.id };

        console.log(schedule_data);
        // 성공했을 때는? 액션 디스패치!
        dispatch(addSchedule(schedule_data));
      })
      .catch((err) => {
        // 여긴 에러가 났을 때 들어오는 구간입니다!
        console.log(err);
        window.alert("오류가 났네요! 나중에 다시 시도해주세요!");
      });
  };
};

export const updateScheduleFB = (desc) => {
  return function (dispatch, getState) {
    const before_state = getState().calendar.schedules.filter((schedule) => {
      if (schedule.desc === desc) {
        return schedule;
      }
    });
    if (!before_state[0]) {
      return;
    }
    let schedule_data = { ...before_state[0], completed: true };
    console.log(schedule_data);

    schedule
      .doc(schedule_data.id)
      .update(schedule_data)
      .then((res) => {
        dispatch(updateSchedule(desc));
      })
      .catch((err) => {
        // 여긴 에러가 났을 때 들어오는 구간입니다!
        console.log(err);
      });
  };
};
export const deleteScheduleFB = (desc) => {
  return function (dispatch, getState) {
    const before_state = getState().calendar.schedules.filter((schedule) => {
      if (schedule.desc === desc) {
        return schedule;
      }
    });
    if (!before_state[0]) {
      return;
    }
    // 삭제하기
    schedule
      .doc(before_state.id)
      .delete()
      .then((res) => {
        dispatch(deleteSchedule(desc));
      })
      .catch((err) => {
        console.log("err");
      });
  };
};
//Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "calendar/LOAD": {
      if (action.schedule.length > 0) {
        return { schedules: action.schedule };
      }
      return state;
    }
    case "calendar/DELETE_SCHEDULE": {
      const new_schedules = state.schedules.filter((schedule) => {
        if (schedule.desc !== action.desc) {
          return schedule;
        }
      });
      return { schedules: new_schedules };
    }
    case "calendar/UPDATE_SCHEDULE": {
      const new_schedules = state.schedules.map((schedule) => {
        if (schedule.desc === action.desc) {
          return { ...schedule, completed: true };
        }

        return schedule;
      });

      return { schedules: new_schedules };
    }

    case "calendar/ADD_SCHEDULE": {
      const new_schedules = [...state.schedules, action.schedule];
      return { schedules: new_schedules };
    }

    default:
      return state;
  }
}
